import { inject, observer } from 'mobx-react';
import * as React from 'react';

import { AnalyticsStore, ExperimentStore } from 'bernie-core';
import { LocalizedComponentProps, withLocalization } from 'bernie-l10n';

import { CurrentHotelStore } from 'stores/current-hotel-store';
import { SearchResultsStore } from 'stores/search-results-store';
import { ShortlistStore } from 'stores/shortlist-store';

import { MapSheetWrapper } from 'components/common/map/sheets/map-sheet-wrapper';

export interface DynamicSheetProps {
  analytics?: AnalyticsStore;
  selectedHotel: any;
  selectedMarker: any;
  shortlist?: ShortlistStore;
  experiment?: ExperimentStore;
  searchResults?: SearchResultsStore;
  currentHotel?: CurrentHotelStore;
  onFavoriteClick: () => void;
  splitView?: boolean;
}

export type LocalizedDynamicSheetProps = LocalizedComponentProps & DynamicSheetProps;

@withLocalization
@inject('routeStore', 'analytics', 'searchResults', 'shortlist', 'experiment', 'currentHotel')
@observer
export class DynamicSheet extends React.Component<LocalizedDynamicSheetProps> {
  public constructor(props) {
    super(props);

    this.onSheetClick = this.onSheetClick.bind(this);
  }

  public render() {
    const { l10n, onFavoriteClick, selectedMarker, selectedHotel, splitView } = this.props;

    if (!selectedHotel || !selectedMarker || !selectedMarker.sheet) {
      return null;
    }

    return (
      <MapSheetWrapper
        sheet={selectedMarker.sheet}
        isVisible={true}
        onClick={this.onSheetClick}
        onFavoriteClick={onFavoriteClick}
        selectedHotel={selectedHotel}
        l10n={l10n}
        splitView={splitView}
      />
    );
  }

  private onSheetClick() {
    const selectedHotel = this.props.selectedHotel.sheet
      ? this.props.searchResults.findHotel(this.props.selectedHotel.sheet.id)
      : this.props.selectedHotel;
    this.props.currentHotel.setSearchResultAsCurrentHotel(selectedHotel);
  }
}
